import { render, staticRenderFns } from "./imgF.vue?vue&type=template&id=d3d536b2"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3d536b2')) {
      api.createRecord('d3d536b2', component.options)
    } else {
      api.reload('d3d536b2', component.options)
    }
    module.hot.accept("./imgF.vue?vue&type=template&id=d3d536b2", function () {
      api.rerender('d3d536b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgF.vue"
export default component.exports